import React from "react";
import {
  Box,
  Image,
  Text,
  HStack,
  IconButton,
  Flex,
  Spacer,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import { Link as RouterLink } from "react-router-dom";

import { FiArrowUpRight } from "react-icons/fi";

import badge from "../../../../assets/home/DiscoverDesign/badge.png";
import aignosis from "../../../../assets/cards/aignosis.png";
import srapp from "../../../../assets/cards/srapp.png";
import wavy from "../../../../assets/cards/wavy.png";
import sitha from "../../../../assets/cards/sitha.png";
import wedmonkey from "../../../../assets/cards/wedmonkey.png";
import indiacourt from "../../../../assets/cards/indiacourt.png";
import rrumi from "../../../../assets/cards/rrumi.png";

// Sample data for cards
const cards = [
  {
    id: 1,
    title: "Aignosis",
    slug: "aignosis",
    bgColor: "#100217",
    gradientColors: ["rgba(182, 56, 255, 0.4)", "rgba(182, 56, 255, 0.4)"],
    image: aignosis,
    badge: badge,
    description:
      "Aignosis is a cutting-edge platform for quick and accurate autism detection in kids. With an intuitive interface and expert-backed assessments, it delivers reliable insights for parents. Our team handled UI/UX, development, branding, and marketing. ",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 2,
    title: "India Court",
    slug: "indiacourt",
    bgColor: "#0C3420",
    gradientColors: ["rgba(67, 199, 76, 0.4)", "rgba(67, 199, 76, 0.4)"],
    image: indiacourt,
    badge: null,
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 3,
    title: "R'Rumi Diamond",
    slug: "rrumi",
    bgColor: "#003445",
    gradientColors: ["rgba(12, 156, 178, 0.7)", "rgba(12, 156, 178, 0.7)"],
    image: rrumi,
    badge: null,
    description:
      "Rrumi Diamond is a Dubai-based luxury jewelry brand offering high-end diamond collections for a sophisticated international clientele. With a seamless online shopping experience, it features GIA-certified diamonds, bespoke designs, and timeless craftsmanship.",
    engagement: "10mins",
    rating: "4.9/5",
  },
  {
    id: 4,
    title: "Wavvy",
    slug: "wavvy",
    bgColor: "#3B0045",
    gradientColors: ["rgba(161, 75, 164, 0.7)", "rgba(161, 75, 164, 0.7)"],
    image: wavy,
    badge: null,
    description:
      "Wavvy is a salon booking app designed for effortless appointment scheduling and seamless beauty service access. It creates an engaging digital space for salons, spas, and dermatologists to interact and grow their business.",
    engagement: "15mins",
    rating: "4.8/5",
  },
  {
    id: 5,
    title: "WedMonkey",
    slug: "wedmonkey",
    bgColor: "#470E30",
    gradientColors: ["rgba(202, 42, 116, 0.4)", "rgba(202, 42, 116, 0.4)"],
    image: wedmonkey,
    badge: null,
    description:
      "WedMonkey offers a curated collection of wedding cards for every style, tradition, and budget. From elegant digital invites to classic prints and modern designs, it makes wedding card selection seamless and hassle-free.",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 6,
    title: "SR App",
    slug: "srapp",
    bgColor: "#0D0832",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: srapp,
    badge: null,
    description:
      "SR App is a smart school management platform for parents, teachers, and administrators. It makes attendance, announcements, homework, fees, and student progress easy to track. Stay connected and organized effortlessly!",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 7,
    title: "LMS App",
    slug: "lmsapp",
    bgColor: "#1D0BA2",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: srapp,
    badge: null,
    description:
      "India Court is a legal platform providing free law education, legal assistance, and lawyer services. Get expert advice, document verification, case references, and direct lawyer consultations—all in one place. Legal help made easy and hassle-free!",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 8,
    title: "Sitha App",
    slug: "sitha",
    bgColor: "#030D3D",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: sitha,
    badge: null,
    description:
      "Sitha is a women-led service marketplace that connects skilled women professionals with customers. From beauty and wellness to home services, Sitha makes booking safe, easy, and empowering.",
    engagement: "12mins",
    rating: "4.7/5",
  },
  {
    id: 9,
    title: "Souls of India",
    slug: "soi",
    bgColor: "#62066B",
    gradientColors: ["rgba(299, 209, 255, 0.4)", "rgba(299, 209, 255, 0.4)"],
    image: wedmonkey,
    badge: null,
    description:
      "Souls of India is a storytelling-driven e-commerce platform that celebrates India’s rich cultural heritage, mindful living, and artisanal craftsmanship. The website showcases handcrafted products, traditional art forms, and soulful stories of Indian artisans—bringing conscious commerce and cultural storytelling together on one platform.",
    engagement: "12mins",
    rating: "4.7/5",
  },
];

const DesignCards = () => {
  return (
    <Box
      backgroundColor="#F7EAD9"
      py={6}
      px={3}
      position="relative"
      fontFamily={"Archivo"}
    >
      {/* Left Arrow */}
      <IconButton
        aria-label="Previous"
        // icon={<FaChevronLeft color="#BFA585" />}
        position="absolute"
        left="0"
        top="50%"
        transform="translateY(-50%)"
        zIndex="10"
        background="transparent"
        color="#BFA585"
        _hover={{ background: "rgba(0, 0, 0, 0.8)" }}
        className="swiper-button-prev"
      />

      {/* Right Arrow */}
      <IconButton
        aria-label="Next"
        // icon={<FaChevronRight color="#BFA585" />}
        position="absolute"
        right="0"
        top="50%"
        transform="translateY(-50%)"
        zIndex="10"
        background="transparent"
        color="#BFA585"
        _hover={{ background: "rgba(0, 0, 0, 0.8)" }}
        className="swiper-button-next"
      />

      <Swiper
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        spaceBetween={15}
        freeMode={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        modules={[Autoplay, FreeMode, Navigation]}
      >
        {cards.map((card) => (
          <SwiperSlide key={card.id}>
            <Flex
              className="fade-in-up"
              bg={card.bgColor}
              borderRadius="20px"
              p={4}
              direction="column"
              color="white"
              height={{ base: "400px", md: "490px" }}
              position="relative"
              overflow="hidden"
            >
              {/* Circular Gradient Background */}
              <Box
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                w="300px"
                h="300px"
                borderRadius="50%"
                background={`radial-gradient(circle, ${card.gradientColors[0]}, ${card.gradientColors[1]}, transparent 100%)`}
                filter="blur(20px)"
                opacity="0.8"
                zIndex="0"
              />

              {/* Badge */}
              {card.badge && (
                <Image
                  src={card.badge}
                  alt="Featured Badge"
                  position="absolute"
                  top="10px"
                  left="10px"
                  width="120px"
                  zIndex="1"
                />
              )}

              {/* Image Container */}
              <Box
                h={{ base: "120px", md: "220px" }}
                mt={10}
                display="flex"
                justifyContent="center"
                position="relative"
                zIndex="1"
              >
                <Image
                  src={card.image}
                  alt="Card Image"
                  objectFit="contain"
                  maxH="100%"
                />
              </Box>

              {/* Spacer to push content to bottom */}
              <Spacer />

              {/* Content */}
              <Box position="relative" zIndex="1">
                {/* Website Title & Link */}
                <ChakraLink
                  as={RouterLink}
                  to={`/our-work/${card.slug}`}
                  fontSize="lg"
                  fontWeight="bold"
                  display="flex"
                  alignItems="center"
                  mb={2}
                  _hover={{ textDecoration: "underline", color: "#FDD9A0" }}
                >
                  {card.title}
                  <FiArrowUpRight style={{ marginLeft: "8px" }} />
                </ChakraLink>

                {/* Description */}
                <Text
                  fontSize="0.8rem"
                  fontWeight={"normal"}
                  fontFamily="Archivo"
                  textAlign="left"
                  mb={3}
                >
                  {card.description}
                </Text>

                {/* Engagement & Rating */}
                <HStack justifyContent="space-between" spacing={2}>
                  <Text fontSize="sm">
                    <strong>Engagement -</strong> {card.engagement}
                  </Text>
                  <Text fontSize="sm">
                    <strong>User Satisfaction -</strong> {card.rating}
                  </Text>
                </HStack>
              </Box>
            </Flex>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default DesignCards;
